import Vue from 'vue';

const success = (context, response) => {
    context.bookings = response.bookings;
    context.filteredBookings = response.bookings;
};

const failed = (context, error) => {
};

export default (context, date) => {
  let url = `superconciergerie/bookings`;
  if(date && date.month && date.year) {
    url += `?year=${date.year}&month=${date.month}`;
  }
  return Vue.$http.get(url)
    .then(response => {
      success(context, response.data);
    }).catch(error => {
      failed(context, error);
    })
}



// WEBPACK FOOTER //
// ./src/app/services/superconciergerie/get-bookings.js